// extracted by mini-css-extract-plugin
module.exports = {"volumeContainer":"LdczvT","volume":"_3j1iQg","active":"y6Lk2w","volumePreview":"bU4HcG","text":"_25YY_2","excerpt":"_2KAPlD"};